<template>
  <div class="my-security-capital">
    <div class="warnTip">{{safetyPage.tip}}</div>
    <div class="myItems" v-if="userInfo.withdrawPassWordState">
      <span class="item1">{{safetyPage.oldPass}}</span>
      <el-input v-model="oldPassword" type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip1}}</span>
    </div>
    <div class="myItems">
      <span class="item1">{{safetyPage.newPass}}</span>
      <el-input v-model="newPassword" type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip2}}</span>
    </div>
    <div class="myItems">
      <span class="item1">{{safetyPage.ConfirmPassword}}</span>
      <el-input v-model="newPassword2" type="password"></el-input>
      <span class="item3">*</span>
      <span class="item4">{{safetyPage.tip3}}</span>
    </div>
    <div class="mytButton">
      <span class="btnConfirm" @click="withdrawPass">{{safetyPage.confirm}}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    safetyPage(){
      return this.$t('safetyPage')
    }
  },
  methods: {
    withdrawPass() {
      let _obj, _str;
      if (this.userInfo.withdrawPassWordState) {
        if (!this.$utils.withPassword(this.oldPassword)) {
          this.$message.error(this.safetyPage.tip4);
          return;
        }
        _obj = {
          newWithdrawpassword: this.newPassword,
          withdrawpassword: this.oldPassword,
        };
        _str =this.safetyPage.ransactionsuc;
      } else {
        _obj = { withdrawpassword: this.newPassword };
        _str = this.safetyPage.Transactionsuc;
      }
      if (!this.$utils.withPassword(this.newPassword)) {
        this.$message.error( this.safetyPage.tip4);
         return;
      }
      if (this.newPassword != this.newPassword2) {
        this.$message.error(this.safetyPage.notthesame);
         return;
      }

      this.$nkhttp.http(this.$api.withdrawPass,_obj,'post',data=>{
        this.$store.commit("updataUserInfo", { withdrawPassWordState: true });
        this.$message.success(_str);
        this.oldPassword = "";
        this.newPassword = "";
        this.newPassword2 = "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-security-capital {
}
</style>